<template>
  <div class="row-panel base-app-panel">
    <div class="column-panel full-height margin-lr-panel" style="width: 580px">
      <!-- Commands Panel -->
      <h3>Commands</h3>
      <div class="row-panel full-width card-style" style="height: 450px">
        <div class="column-panel full-height margin-lr-panel" style="width: 230px">
          <v-btn
            color="blue"
            class="mt-4 one-line-element command-button"
            x-small
            @click="buttonNameClick"
            >Name</v-btn
          >
          <div class="mt-2 field-wrapper">
            <v-btn color="blue" class="one-line-element" x-small @click="buttonEchoClick" style="width: 50px"
              >Echo</v-btn
            >
            <v-text-field class="text-field not-first-field" hide-details type="input" v-model="echoCommandData" style="width: 160px; vertical-align: top"/>
          </div>
          <v-btn
            color="blue"
            class="mt-2 one-line-element command-button"
            x-small
            @click="buttonAdcOnClick"
            >Adc On</v-btn
          >
          <v-btn
            color="blue"
            class="mt-2 one-line-element command-button"
            x-small
            @click="buttonAdcOffClick"
            >Adc Off</v-btn
          >
          <v-btn
            color="blue"
            class="mt-2 one-line-element command-button"
            x-small
            @click="buttonFlashDataOnClick"
            >Flash Data On</v-btn
          >
          <v-btn
            color="blue"
            class="mt-2 one-line-element command-button"
            x-small
            @click="buttonFlashDataOffClick"
            >Flash Data Off</v-btn
          >
        </div>
        <!-- Custom Command Panel -->
        <div class="column-panel full-height margin-lr-panel" style="width: calc(100% - 250px)">
          <h4 style="margin: 5px 0 0 0">Custom command:</h4>
          <div class="mt-2 row-panel full-width one-line-element">
            <label style="width: 60px">Name:</label>
            <v-text-field
              class="text-field not-first-field one-line-element"
              hide-details
              type="input"
              v-model="customCommandName"
              style="width: 160px"
            />
            <v-btn
              color="blue"
              class="ml-2 one-line-element"
              x-small
              @click="buttonSendCustomCommandClick"
              style="width: 60px"
              >Send</v-btn
            >
          </div>
          <label class="mt-2" style="width: 60px">Body:</label>
          <div class="not-first-line" style="width: 100%; height: 160px">
            <v-textarea
              class="textarea-field"
              hide-details
              no-resize
              v-model="customCommandBody"
              style="width: calc(100% - 10px); height: 100%"
            />
          </div>
          <label class="mt-2" style="width: 80px">Answer:</label>
          <div class="not-first-line" style="width: 100%; height: 120px">
            <v-textarea
              class="textarea-field"
              hide-details
              no-resize
              readonly
              v-model="customCommandAnswer"
              style="width: calc(100% - 10px); height: 100%"
            />
          </div>
        </div>
      </div>
      <!-- Echo Test Panel -->
      <h3 class="mt-4">Echo Test</h3>
      <div class="column-panel full-width card-style" style="height: 420px">
        <!-- Start/Stop Echo Test Panel -->
        <div class="mt-4 row-panel margin-lr-panel one-line-element" style="width: calc(100% - 20px)">
          <v-btn
            color="blue"
            class="one-line-element"
            x-small
            @click="buttonStartEchoTestClick"
            style="width: 100px"
            >Start</v-btn
          >
          <v-btn
            color="blue"
            class="ml-2 one-line-element"
            x-small
            @click="buttonStopEchoTestClick"
            style="width: 100px"
            >Stop</v-btn
          >
          <CheckBoxField title="Show in terminal" v-model="cbEchoTestCommandInTerminal" :isReadonly="false" style="width: 100%" class="ml-2" />
        </div>
        <!-- Speed Mode Panel -->
        <div class="mt-4 row-panel full-width" style="height: 200px">
          <div class="column-panel margin-lr-panel full-height" style="width: 200px">
            <h4 style="text-decoration: underline">Speed Mode:</h4>
            <v-radio-group v-model="echoTestSpeed" column>
              <v-radio label="Continuously" value="0" />
              <v-radio value="1" :label="`With delay ${echoTestDelays[0]} ms`" />
              <v-radio value="2" :label="`With delay ${echoTestDelays[1]} ms`" />
            </v-radio-group>
          </div>
          <div class="column-panel margin-lr-panel full-height" style="width: calc(100% - 200px)">
            <h4 style="text-decoration: underline">Data:</h4>
            <v-radio-group v-model="echoTestData" column>
              <v-radio label="Random" value="0" @click="handleRandomEchoDataClick"></v-radio>
              <div id="echoTestRandomDataSettings" style="display: none">
                <label for="numEchoTestRandomData_From">Length from</label>
                <input
                  type="number"
                  id="numEchoTestRandomData_From"
                  min="1"
                  max="10000"
                  style="margin-left: 5px"
                  class="numeric_field"
                />
                <label for="numEchoTestRandomData_To" style="margin-left: 5px">to</label>
                <input
                  type="number"
                  id="numEchoTestRandomData_To"
                  min="1"
                  max="10000"
                  style="margin-left: 5px"
                  class="numeric_field"
                />
              </div>
              <v-radio label="Fixed" value="1" @click="handleFixedEchoDataClick"></v-radio>
              <div id="echoTestFixedDataSettings" style="display: none">
                <input type="text" id="txtFixedEchoData" class="text_field" style="width: 200px" />
              </div>
            </v-radio-group>
          </div>
        </div>
        <!-- Statistics Panel -->
        <h4 class="mt-4 margin-lr-panel" style="text-decoration: underline">Statistics:</h4>
        <div class="mt-2 row-panel full-width margin-lr-panel" style="height: 200px">
          <div class="column-panel full-height" style="width: 260px">
            <h4 style="font-style: italic">Total:</h4>
            <div class="row-panel one-line-element full-width">
              <label class="statistics-label">Send:</label>
              <input
                type="text"
                style="margin-left: 5px; width: 80px"
                class="text_field"
                readonly
                v-model="sendBytesTotalCountText"
              />
              <label style="margin-left: 5px">bytes</label>
            </div>
            <div class="row-panel one-line-element full-width">
              <label class="statistics-label">Received:</label>
              <input
                type="text"
                style="margin-left: 5px; width: 80px"
                class="text_field"
                readonly
                v-model="receivedBytesTotalCountText"
              />
              <label style="margin-left: 5px">bytes</label>
            </div>
          </div>
          <div class="column-panel full-height" style="width: 260px">
            <h4 style="font-style: italic">Speed:</h4>
            <div class="row-panel one-line-element full-width">
              <label class="statistics-label">Send:</label>
              <input type="text" style="margin-left: 5px; width: 80px" class="text_field" readonly v-model="sendBytesSpeedText" />
              <label style="margin-left: 5px">bytes/sec</label>
            </div>
            <div class="row-panel one-line-element full-width">
              <label class="statistics-label">Received:</label>
              <input type="text" style="margin-left: 5px; width: 80px" class="text_field" readonly v-model="receivedBytesSpeedText" />
              <label style="margin-left: 5px">bytes/sec</label>
            </div>
          </div>
        </div>
        <div class="mt-2 column-panel full-width margin-lr-panel" style="height: 200px">
          <div class="row-panel one-line-element full-width">
            <label class="statistics-label">Errors:</label>
            <input type="text" style="margin-left: 5px; width: 80px" class="text_field" readonly v-model="echoTestErrorCountText" />
          </div>
          <div class="row-panel one-line-element full-width">
            <label class="statistics-label">Time:</label>
            <input type="text" style="margin-left: 5px; width: 160px" class="text_field" readonly v-model="echoTestTimeText" />
          </div>
        </div>
      </div>
    </div>
    <div class="column-panel full-height margin-lr-panel" style="width: calc(100% - 620px)">
      <!-- Visualizator Panel -->
      <div class="column-panel full-width" style="height: 55%">
        <OnlineCanvas :settings="canvasSettings" style="position: relative" @initialized="onVisualizatorInitializeFinished" />
      </div>
      <!-- Terminal Controls Panel -->
      <div class="row-panel full-width" style="align-items: center; height: 40px; margin-top: 5px;">
        <v-btn
          color="blue"
          class="one-line-element"
          x-small
          @click="buttonClearTerminalClick"
          style="margin: 0px 0 0px 20px; width: 100px"
          >Clear</v-btn
        >
        <CheckBoxField title="Show debug info" v-model="cbShowDebugInfo" :isReadonly="false" class="ml-2" style="width: 200px" />
      </div>
      <!-- Terminal Panel -->
      <div class="column-panel" style="margin: 5px !important; width: calc(100% - 10px); height: calc(45% - 50px)">
        <div id="terminal" class="full-width full-height terminal-panel" style="margin: 0px !important"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { markRaw } from "vue";
import { byteDataTextConverter } from "@/api/byteDataTextConverter";
import { getNetworkSettings } from "@/api/get-network-settings";
import {
  sendDeviceCommand,
  sendJsonGetRequestToServer,
  WSController,
  SseController,
  DeviceError
} from "@/submodules/visualizator-common-components";
import { IdGenerator } from "@/submodules/web-visualizator";
import { createUserSettings, OnlineVisualizatorProvider } from "@/submodules/visualizator-common-components/js/visualizators";
import OnlineCanvas from "@/submodules/visualizator-common-components/vue/online/online-canvas.vue";
import CheckBoxField from "@/components/CheckBoxField.vue";

export default {
  name: "App",
  components: {
    OnlineCanvas,
    CheckBoxField
  },
  data: () => ({
    sendBytesTotalCountText: "0",
    receivedBytesTotalCountText: "0",
    sendBytesSpeedText: "0",
    receivedBytesSpeedText: "0",
    echoTestErrorCountText: "0",
    echoTestTimeText: "0",
    echoTestDelays: [500, 1000],
    echoCommandData: "",
    echoTestSpeed: "0",
    echoTestData: "0",
    customCommandName: "",
    customCommandBody: "",
    customCommandAnswer: "",
    cbEchoTestCommandInTerminal: false,
    cbShowDebugInfo: false,
    deviceIsConnected: false,
    commandUidGenerator: new IdGenerator(),
    canvasSettings: undefined,
    viewSettings: undefined,
    terminalSymbolLimit: 500000
  }),
  watch: {
    echoTestSpeed(newValue) {
      if (newValue !== null) {
        this.currEchoTestSpeedMode = newValue;
      }
    }
  },
  methods: {
    async sendCommandToDevice(commandName, commandData) {
      return await sendDeviceCommand(
        this.networkSettings.DeviceAdapterUrl,
        this.commandUidGenerator.generateNextId(),
        commandName,
        commandData
      ).catch(err => {
        if (err instanceof DeviceError) {
          if (err.code == "locking") {
            console.log(`Command '${commandName}' can't executed in this device state`);
          } else {
            console.log(`Command '${commandName}' is failed: ${err.message}`);
          }
          this.addRecordToTerminal(`Command "${commandName}" Error: ${err.message}`, 1);
        } else {
          this.handleHttpError(err.message);
        }
      });
    },
    async sendHandledCommandToDevice(commandName, commandData) {
      return await sendDeviceCommand(
        this.networkSettings.DeviceAdapterUrl,
        this.commandUidGenerator.generateNextId(),
        commandName,
        commandData
      );
    },
    handleUsbDriverError(event) {
      this.addRecordToTerminal(event.message, 1);
    },
    addSendCommandRecordToTerminal(commandName, commandData) {
      let commandDataText = "[";
      for (let i = 0; i < commandData.length; i++) {
        if (i > 0) {
          commandDataText += ", ";
        }
        commandDataText += commandData[i];
      }
      commandDataText += "]";
      let recordText = 'Send command "' + commandName + '" with data: ' + commandDataText;
      this.addRecordToTerminal(recordText, 6);
    },
    addCommandAnswerRecordToTerminal(commandName, answer) {
      let answerText = "[";
      for (let i = 0; i < answer.length; i++) {
        if (i > 0) {
          answerText += ", ";
        }
        answerText += answer[i];
      }
      answerText += "]";
      this.addRecordToTerminal(`Command "${commandName}" answer: ${answerText}`, 2);
    },
    handleHttpError(status) {
      this.addRecordToTerminal(`Http Error: ${status}`, 1);
    },
    handleDeviceCommandError(commandName, errorText) {
      this.addRecordToTerminal(`Command "${commandName}" error: ${errorText}`, 1);
    },
    clearTerminal() {
      document.getElementById("terminal").innerHTML = "";
    },
    addRecordToTerminal(text, color) {
      let currDate = new Date();
      let timeText =
        (currDate.getHours() < 10 ? "0" : "") +
        currDate.getHours() +
        ":" +
        (currDate.getMinutes() < 10 ? "0" : "") +
        currDate.getMinutes() +
        ":" +
        (currDate.getSeconds() < 10 ? "0" : "") +
        currDate.getSeconds() +
        ":" +
        (currDate.getMilliseconds() < 100 ? "0" : "") +
        (currDate.getMilliseconds() < 10 ? "0" : "") +
        currDate.getMilliseconds();
      let textColor = this.selectTerminalColor(color);
      let lineText = `<span style="color: ` + textColor + `;">[` + timeText + "] " + text + "</span><br>";
      this.addNewLineToTerminal(lineText);
    },
    addNewLineToTerminal(lineText) {
      let terminalDiv = document.getElementById("terminal");
      let text = `<span style="color: #999999;">$> </span>` + lineText.replaceAll("\r", "").replaceAll("\n", "<br>");
      this.addTextToTerminal(text);
      terminalDiv.innerHTML += text;
    },
    addTextToTerminal(newText) {
      let terminalDiv = document.getElementById("terminal");
      let text = terminalDiv.innerHTML;
      //text = text.trim();
      let lines = text.split("<br>");
      let sum = newText.length;
      let deleteIndex = -1;
      for (let i = lines.length - 1; i >= 0; i--) {
        //console.log(" i=" + i + "; " + lines[i]);
        if (sum + lines[i].length + 4 > this.terminalSymbolLimit) {
          deleteIndex = i;
          break;
        } else {
          sum += lines[i].length + 4;
        }
      }
      if (deleteIndex >= 0) {
        if (deleteIndex == lines.length - 1) {
          text = "";
        } else {
          let remainsLines = lines.slice(deleteIndex + 1);
          text = remainsLines.join("<br>");
        }
        terminalDiv.innerHTML = text;
      }
    },
    selectTerminalColor(number) {
      switch (number) {
        case 0:
          return "white";
        case 1:
          return "red";
        case 2:
          return "lightgreen";
        case 3:
          return "yellow";
        case 4:
          return "blue";
        case 5:
          return "magenta";
        case 6:
          return "cyan";
        case 7:
          return "white";
        default:
          return "white";
      }
    },
    async sendEchoCommand(data) {
      this.addSendCommandRecordToTerminal("Echo", data);
      //await this.sendCommandToDevice("GetCableModes", {})
      const answer = await this.sendCommandToDevice("Echo", data);
      this.addCommandAnswerRecordToTerminal("Echo", answer.data);
    },
    getRandomInt(min, max) {
      return Math.floor(Math.random() * (max + 1 - min)) + min;
    },
    convertIntToHex(number, size) {
      let num = number.toString(16);
      while (num.length < size) {
        num = "0" + num;
      }
      return num;
    },
    async sendCustomCommand(commandName, commandData) {
      this.addRecordToTerminal(`Send command "${commandName}": ${JSON.stringify(commandData, null, ' ')}`, 0);
      const answer = await this.sendCommandToDevice(commandName, commandData);
      this.customCommandAnswer = JSON.stringify(answer, null, ' ');
      this.addCommandAnswerRecordToTerminal(commandName, answer.data);
    },
    async buttonNameClick() {
      this.addSendCommandRecordToTerminal("Name", []);
      const answer = await this.sendCommandToDevice("Name", {});
      this.addCommandAnswerRecordToTerminal("Name", answer.data);
    },
    async buttonEchoClick() {
      let commandData = byteDataTextConverter.convert(this.echoCommandData);
      console.log(`[buttonEchoClick] commandData=${JSON.stringify(commandData)}`);
      if (!commandData.Success) {
        alert("Bad data for Echo command!");
        return;
      }
      await this.sendEchoCommand(commandData.Result);
    },
    async buttonAdcOnClick() {
      this.addSendCommandRecordToTerminal("AdcOn", {});
      const answer = await this.sendCommandToDevice("AdcOn", {});
      this.addCommandAnswerRecordToTerminal("AdcOn", answer.data);
    },
    async buttonAdcOffClick() {
      this.addSendCommandRecordToTerminal("AdcOff", {});
      const answer = await this.sendCommandToDevice("AdcOff", {});
      this.addCommandAnswerRecordToTerminal("AdcOff", answer.data);
    },
    async buttonFlashDataOnClick() {
      this.addSendCommandRecordToTerminal("FlashDataOn", []);
      const answer = await this.sendCommandToDevice("FlashDataOn", {});
      this.addCommandAnswerRecordToTerminal("FlashDataOn", answer.data);
    },
    async buttonFlashDataOffClick() {
      this.addSendCommandRecordToTerminal("FlashDataOff", []);
      const answer = await this.sendCommandToDevice("FlashDataOff", {});
      this.addCommandAnswerRecordToTerminal("FlashDataOff", answer.data);
    },
    async buttonSendCustomCommandClick() {
      const commandDataText = this.customCommandBody.trim();
      let commandData = undefined;
      if (commandData != "") {
        if (commandDataText[0] == "{") {
          commandData = JSON.parse(commandDataText);
        } else {
          // try parse bytes
          const parsedCommandData = byteDataTextConverter.convert(commandDataText);
          if (!parsedCommandData.Success) {
            this.addRecordToTerminal(`Create Command Error: Can't create custom command. Data format is wrong!`, 1);
            return;
          }
          commandData = parsedCommandData.Result;
        }
      } else {
        commandData = {};
      }
      await this.sendCustomCommand(this.customCommandName, commandData);
    },
    async buttonStartEchoTestClick() {
      await this.startEchoTest();
    },
    buttonStopEchoTestClick() {
      this.stopEchoTest();
    },
    buttonClearTerminalClick() {
      this.clearTerminal();
    },
    async sendEchoTestCommand() {
      const commandData = this.createEchoTestData();
      this.lastEchoTestData = commandData;
      const showInTerminalFlag = this.cbEchoTestCommandInTerminal;
      this.echoTestCurrSendBytesCount += commandData.length;
      this.echoTestTotalSendBytes += commandData.length;
      this.sendBytesTotalCountText = this.echoTestTotalSendBytes.toString();
      console.log(`sendEchoTestCommand ${commandData}`);
      if (showInTerminalFlag) {
        this.addSendCommandRecordToTerminal("Echo", commandData);
      }
      return await this.sendHandledCommandToDevice("Echo", commandData);
    },
    async sendContinuouslyEchoCommand() {
      if (this.echoTestStopped) {
        return;
      }
      this.lastEchoTestTimeStamp = Date.now();

      try {
        const answer = await this.sendEchoTestCommand();
        this.handleContinuouslyEchoCommandAnswer(answer);
      } catch (err) {
        if (err instanceof DeviceError) {
          this.handleUsbDriverError(err.message);
        } else {
          this.handleHttpError(err.message);
        }
      }
    },
    async sendEchoTestCommandByTimer() {
      try {
        const answer = await this.sendEchoTestCommand();
        this.handleTimerEchoCommandAnswer(answer);
      } catch (err) {
        if (err instanceof DeviceError) {
          this.handleUsbDriverError(err.message);
        } else {
          this.handleHttpError(err.message);
        }
      }
    },
    startEchoTestWithDelay(delay) {
      this.lastEchoTestTimeStamp = Date.now();
      this.echoTimer = setInterval(this.sendEchoTestCommandByTimer, delay);
    },
    clearEchoTestFieldsBeforeStart() {
      this.echoTestErrorCount = 0;
      this.echoTestTotalSendBytes = 0;
      this.echoTestTotalReceivedBytes = 0;
      this.echoTestSendBytesSpeed = 0;
      this.echoTestReceivedBytesSpeed = 0;
      this.echoTestTime = 0;
      this.echoTestCurrSendBytesCount = 0;
      this.echoTestCurrReceivedBytesCount = 0;
      this.lastEchoTestTimeStamp = 0;
      this.echoTestErrorCountText = "0";
      this.sendBytesTotalCountText = "0";
      this.receivedBytesTotalCountText = "0";
      this.sendBytesSpeedText = "0";
      this.receivedBytesSpeedText = "0";
      this.echoTestTimeText = this.getTimeText(0);
    },
    getTimeText(time) {
      let milliseconds = time % 1000;
      let seconds = Math.floor(time / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      seconds = seconds % 60;
      minutes = minutes % 60;

      let text = "";
      if (hours < 10) {
        text += "0";
      }
      text += hours.toString() + ":";
      if (minutes < 10) {
        text += "0";
      }
      text += minutes.toString() + ":";
      if (seconds < 10) {
        text += "0";
      }
      text += seconds.toString() + ",";
      if (milliseconds < 100) {
        text += "0";
        if (milliseconds < 10) {
          text += "0";
        }
      }
      text += milliseconds.toString();
      return text;
    },
    async startEchoTest() {
      this.stopEchoTest();
      this.echoTestSpeedMode = this.currEchoTestSpeedMode;
      this.echoTestStopped = false;
      this.currEchoTestTime = 0; // in ms
      this.clearEchoTestFieldsBeforeStart();
      if (!this.fillEchoTestDataInfo()) {
        alert("Bad data for Echo command!");
        return;
      }
      if (this.echoTestSpeedMode == 0) {
        while (!this.echoTestStopped) {
          await this.sendContinuouslyEchoCommand();
        }
      } else {
        this.startEchoTestWithDelay(this.echoTestDelays[this.echoTestSpeedMode - 1]);
      }
    },
    stopEchoTest() {
      this.echoTestStopped = true;
      if (this.echoTimer != null) {
        clearInterval(this.echoTimer);
        this.echoTimer = null;
      }
    },
    fillEchoTestDataInfo() {
      let commandDataText;
      let parsedCommandData;
      switch (this.echoTestDataMode) {
        case 0: // Random
          this.echoTestRandomDataLengthFrom = parseInt(document.getElementById("numEchoTestRandomData_From").value);
          this.echoTestRandomDataLengthTo = parseInt(document.getElementById("numEchoTestRandomData_To").value);
          return true;
        case 1: // Fixed
          commandDataText = document.getElementById("txtFixedEchoData").value;
          parsedCommandData = byteDataTextConverter.convert(commandDataText);
          if (!parsedCommandData.Success) {
            return false;
          }
          this.echoTestFixedData = parsedCommandData.Result;
          return true;
      }
      return false;
    },
    createEchoTestData() {
      let dataLength;
      let commandData = [];
      switch (this.echoTestDataMode) {
        case 0: // Random
          dataLength = this.getRandomInt(this.echoTestRandomDataLengthFrom, this.echoTestRandomDataLengthTo);
          for (let i = 0; i < dataLength; i++) {
            commandData.push("0x" + this.convertIntToHex(this.getRandomInt(0, 255), 2));
          }
          return commandData;
        case 1: // Fixed
          return this.echoTestFixedData;
      }
      return [];
    },
    showRandomEchoDataSettings() {
      this.echoTestDataMode = 0;
      document.getElementById("echoTestFixedDataSettings").style.display = "none";
      document.getElementById("echoTestRandomDataSettings").style.display = "block";
      document.getElementById("numEchoTestRandomData_From").value = "1";
      document.getElementById("numEchoTestRandomData_To").value = "20";
    },
    showFixedEchoDataSettings() {
      this.echoTestDataMode = 1;
      document.getElementById("echoTestRandomDataSettings").style.display = "none";
      document.getElementById("echoTestFixedDataSettings").style.display = "block";
      document.getElementById("txtFixedEchoData").value = "";
    },
    handleEchoTestCommandAnswer(answer) {
      if (answer.status != "ok") {
        this.echoTestErrorCount++;
        this.echoTestErrorCountText = this.echoTestErrorCount.toString();
        return;
      }
      this.echoTestCurrReceivedBytesCount += answer.data.length;
      this.echoTestTotalReceivedBytes += answer.data.length;
      this.receivedBytesTotalCountText = this.echoTestTotalReceivedBytes.toString();
      let errorText = this.checkReceivedEchoTestAnswer(answer.data);
      if (errorText != null) {
        this.echoTestErrorCount++;
        this.echoTestErrorCountText = this.echoTestErrorCount.toString();
        this.handleDeviceCommandError("Echo", errorText);
        return;
      }
      let showInTerminalFlag = this.cbEchoTestCommandInTerminal;
      if (showInTerminalFlag) {
        this.addCommandAnswerRecordToTerminal("Echo", answer.data);
      }
    },
    checkReceivedEchoTestAnswer(data) {
      if (this.lastEchoTestData.length != data.length) {
        return `Received answer length error: send ${this.lastEchoTestData.length} [${this.convertByteArrayToString(
          this.lastEchoTestData
        )}], received ${data.length} [${this.convertByteArrayToString(data)}]`;
      }
      for (let i = 0; i < data.length; i++) {
        if (!this.textEquals(this.lastEchoTestData[i], data[i])) {
          return `Received answer content error in ${i} position: send ${this.lastEchoTestData[i]}, received ${data[i]}`;
        }
      }
      return null;
    },
    convertByteArrayToString(data) {
      let text = "";
      for (let i = 0; i < data.length; i++) {
        if (i > 0) {
          text += ",";
        }
        text += "0x";
        let byteText = data[i].toString(16);
        if (byteText.length < 2) {
          text += "0";
        }
        text += byteText;
      }
      return text;
    },
    textEquals(a, b) {
      return typeof a === "string" && typeof b === "string" ? a.localeCompare(b, undefined, { sensitivity: "accent" }) === 0 : a === b;
    },
    async handleContinuouslyEchoCommandAnswer(data) {
      let currEchoTestTimeStamp = Date.now() - this.lastEchoTestTimeStamp;
      this.currEchoTestTime += currEchoTestTimeStamp;
      this.handleEchoTestCommandAnswer(data);
      if (this.currEchoTestTime > 1000) {
        this.printSpeedEchoStatistics(this.currEchoTestTime);
        this.currEchoTestTime = 0;
        this.echoTestCurrSendBytesCount = 0;
        this.echoTestCurrReceivedBytesCount = 0;
      }
    },
    printSpeedEchoStatistics(time) {
      this.echoTestTime += time;
      this.echoTestSendBytesSpeed = Math.ceil(this.echoTestCurrSendBytesCount / time * 1000);
      this.echoTestReceivedBytesSpeed = Math.ceil(this.echoTestCurrReceivedBytesCount / time * 1000);
      this.sendBytesSpeedText = this.echoTestSendBytesSpeed.toString();
      this.receivedBytesSpeedText = this.echoTestReceivedBytesSpeed.toString();
      console.log("time=" + time);
      console.log("this.echoTestTime=" + this.echoTestTime);
      this.echoTestTimeText = this.getTimeText(this.echoTestTime);
    },
    handleTimerEchoCommandAnswer(data) {
      console.log(`handleTimerEchoCommandAnswer`);
      let currEchoTestTimeStamp = Date.now() - this.lastEchoTestTimeStamp;
      this.lastEchoTestTimeStamp = Date.now();
      this.currEchoTestTime += currEchoTestTimeStamp;
      this.handleEchoTestCommandAnswer(data);
      if (this.currEchoTestTime > 1000 - this.echoTestTimeDelta) {
        this.printSpeedEchoStatistics(this.currEchoTestTime);
        this.currEchoTestTime = 0;
        this.echoTestCurrSendBytesCount = 0;
        this.echoTestCurrReceivedBytesCount = 0;
      }
    },
    handleTimerEchoCommandHttpError(status) {
      this.handleHttpError(status);
    },
    handleRandomEchoDataClick() {
      this.showRandomEchoDataSettings();
    },
    handleFixedEchoDataClick() {
      this.showFixedEchoDataSettings();
    },
    async handleDeviceConnected() {
      this.addRecordToTerminal("Device connected", 3);
      const freqAnswer = await this.sendCommandToDevice("GetFrequency", "");
      console.log(`[GetFrequency] ${freqAnswer.data.Frequency}`);
      this.visualizatorProvider.setFrequency(undefined, "ecg", freqAnswer.data.Frequency);
      const innerCalibAnswer = await this.sendCommandToDevice("ReadInnerChannelsCalibration", {});
      const channelsInfo = innerCalibAnswer.data.Channels;
      for (let channelIndex = 0; channelIndex < channelsInfo.length; channelIndex++) {
        const channelInfo = channelsInfo[channelIndex];
        this.visualizatorProvider.setCalibration(undefined, channelInfo.Name, channelInfo.Map, channelInfo.clbK, channelInfo.clbB);
      }
      const ecgModeAnswer = await this.sendCommandToDevice("ReadEcgMode", {});
      this.parseEcgMode(ecgModeAnswer);
      if (this.adcSocket === undefined) {
        this.adcSocket = new WSController();
        this.adcSocket.mount(this.networkSettings.AdcWebSocketUrl);
        this.eventSocket = new WSController();
        this.eventSocket.mount(this.networkSettings.EventsWebSocketUrl);
      }
      this.adcSocket.messageHandler = function (message) {
        //console.log(JSON.stringify(message, null, ' ')); // eslint-disable-line
        this.visualizatorProvider?.pushMessage(message);
      }.bind(this);

      this.eventSocket.messageHandler = function (message) {
        console.log(`event: ${JSON.stringify(message, null, ' ')}`); // eslint-disable-line
        if (message.type != "event") {
          return;
        }
        //console.log(JSON.stringify(message, null, ' ')); // eslint-disable-line
        const eventType = message.data.type;
        switch (eventType) {
          case "deviceConnect":
            this.handleDeviceConnected();
            break;
          case "deviceDisconnect":
            this.handleDeviceDisconnected();
            break;
          case "cableConnect":
            this.handleCableConnected();
            break;
          case "cableDisconnect":
            this.handleCableDisconnected();
            break;
          case "error":
            this.handleUsbDriverError(message.data);
            break;
        }
      }.bind(this);

      this.terminalSocket = new WebSocket(this.networkSettings.TerminalWebSocketUrl);
      this.terminalSocket.onmessage = function (event) {
        this.parseWSTerminalMessage(event.data);
      }.bind(this);

      await this.sendCommandToDevice("AdcOn", {});
      const cableExistAnswer = await this.sendCommandToDevice("ReadCableExist", {});
      if (cableExistAnswer.data.IsExist) {
        this.handleCableConnected();
      } else {
        this.handleCableDisconnected();
      }
    },
    parseWSTerminalMessage(message) {
      try {
        const obj = JSON.parse(message);
        if (this.cbShowDebugInfo || obj.Type == "CommandInfo") {
          this.addRecordToTerminal(obj.Text, obj.Color);
        }
      } catch (e) {
        return;
      }
    },
    handleDeviceDisconnected() {
      this.addRecordToTerminal("Device disconnected", 3);
      this.handleCableDisconnected();
    },
    async handleCableConnected() {
      this.cableExists = true;
      this.addRecordToTerminal("Cable connected", 3);
      const cableVersionAnswer = await this.sendCommandToDevice("ReadCableVersion", {});
      this.hasCorrectCableVersion = this.parseCableVersion(cableVersionAnswer);
      if (this.hasCorrectCableVersion) {
        const cableInfoAnswer = await this.sendCommandToDevice("ReadCableInfo", {});
        this.parseCableInfo(cableInfoAnswer);
        const ecgModeAnswer = await this.sendCommandToDevice("ReadEcgMode", {});
        this.parseEcgMode(ecgModeAnswer);
      }
    },
    handleCableDisconnected() {
      this.cableExists = false;
      this.hasCorrectCableVersion = false;
      this.ecgMode = "4";
      this.addRecordToTerminal("Cable disconnected", 3);
      this.updateEcgChannelConfiguration();
    },
    getChannelConfiguration(mode) {
      switch (mode) {
        case "1":
          return "1x3";
        case "2":
          return "3x7";
        case "3":
          return "3x5";
        case "4":
          return "12x10";
      }
      return "12x10";
    },
    parseCableVersion(answer) {
      if (answer.status != "ok") {
        this.handleDeviceCommandError(answer.cmd ?? answer.uid, answer.errorcode);
        this.addRecordToTerminal("Версия кабеля из прошивки не прочитана! Работа с данным кабелем невозможна!", 1);
        return false;
      }
      const cableVersion = answer.data;
      let versionValue = "0x";
      if (cableVersion.HardwareVersion == 0 || cableVersion.HardwareVersion == 0xff) {
        if (cableVersion.HardwareVersion < 16) {
          versionValue += "0";
        }
        versionValue += cableVersion.HardwareVersion.toString(16);
        this.addRecordToTerminal(`Аппаратная версия кабеля равна ${versionValue}! Работа с данным кабелем невозможна!`, 1);
        return false;
      }
      if (cableVersion.SoftwareVersion == 0 || cableVersion.SoftwareVersion == 0xffff) {
        if (cableVersion.SoftwareVersion < 16) {
          versionValue += "0";
        }
        versionValue += cableVersion.SoftwareVersion.toString(16);
        this.addRecordToTerminal(`Программная версия кабеля равна ${versionValue}! Работа с данным кабелем невозможна!`, 1);
        return false;
      }
      return true;
    },
    parseCableInfo(answer) {
      this.lastReadCableInfo = answer.data;
    },
    updateEcgChannelConfiguration() {
      this.visualizatorProvider.setChannelsConfiguration(undefined, "ecg", this.getChannelConfiguration(this.ecgMode));
    },
    async parseEcgMode(answer) {
      this.ecgMode = answer.data.Mode;
      console.log(`[parseEcgMode] ${this.getChannelConfiguration(this.ecgMode)}`);
      this.updateEcgChannelConfiguration();
    },
    handleFlashData(data) {
      this.addRecordToTerminal("Receive Flash data: " + data.length, 5);
    },
    initEchoTestFields() {
      this.echoTimer = null;
      this.currEchoTestSpeedMode = 0; // set when radio button checked changed
      this.echoTestSpeedMode = 0; // set when "start" button pressed
      this.echoTestDataMode = 0; // 0 - Random, 1 - Fixed
      this.echoTestStopped = false;
      this.echoTestRandomDataLengthFrom = 0;
      this.echoTestRandomDataLengthTo = 0;
      this.echoTestFixedData = [];
      this.echoTestErrorCount = 0;
      this.echoTestTotalSendBytes = 0;
      this.echoTestTotalReceivedBytes = 0;
      this.echoTestSendBytesSpeed = 0;
      this.echoTestReceivedBytesSpeed = 0;
      this.echoTestTime = 0;
      this.echoTestCurrSendBytesCount = 0;
      this.echoTestCurrReceivedBytesCount = 0;
      this.echoTestTimeDelta = 100; // допустимая погрешность таймера
      this.lastEchoTestTimeStamp = 0;

      this.echoTestErrorCountText = "0";
      this.sendBytesTotalCountText = "0";
      this.receivedBytesTotalCountText = "0";
      this.sendBytesSpeedText = "0";
      this.receivedBytesSpeedText = "0";
      this.echoTestTimeText = this.getTimeText(0);
    },
    async onVisualizatorInitializeFinished() {
      try {
        await sendDeviceCommand(this.networkSettings.DeviceAdapterUrl, this.commandUidGenerator.generateNextId(), "Echo", "0xFF");
        this.handleDeviceConnected();
      } catch (err) {
        this.handleDeviceDisconnected();
        this.handleHttpError(err.message);
      }
    },
    async initVisSettings() {
      try {
        this.visualizatorProvider = new OnlineVisualizatorProvider();
        const configResponse = await fetch(`./config/visualizator.json`);
        const configData = await configResponse.json();

        this.canvasSettings = {
          visSettings: configData,
          saveableVisSettings: createUserSettings(configData),
          visualizatorProvider: markRaw(this.visualizatorProvider)
        };
        this.viewSettings = this.canvasSettings.visSettings;
      } catch (err) {
        this.handleHttpError(err.message);
      }
    }
  },
  async mounted() {
    this.cableExists = false;
    this.hasCorrectCableVersion = false;
    this.ecgMode = "4";
    this.initEchoTestFields();
    this.showRandomEchoDataSettings();

    this.networkSettings = await getNetworkSettings();
    await this.initVisSettings();
  },
  beforeDestroy() {
    this.terminalSocket.close();
    this.eventSocket.unmount();
    this.adcSocket.unmount();
    this.terminalSocket = undefined;
    this.eventSocket = undefined;
    this.adcSocket = undefined;
  }
};
</script>

<style>
html, body {
  overflow-x: hidden !important;
  overflow-y: hidden !important;
}
</style>

<style lang="scss" scoped>
@use './scss/control-field';
@use './scss/input-field';
@use './scss/text-field';
@use './scss/text-area-field';

.base-app-panel {
  width: 100vw;
  height: 100vh;
  overflow-y: hidden;
}
.column-panel {
  display: flex;
  flex-direction: column;
}
.row-panel {
  display: flex;
  flex-direction: row;
}
.full-width {
  width: 100%;
}
.full-height {
  height: 100%;
}
.margin-lr-panel {
  margin: 0 10px;
}
.card-style {
  border: 1px solid #000000;
  border-radius: 25px;
  box-shadow: 2px 2px 2px 1px #000000;
}
.one-line-element {
  height: 26px;
}
.command-button {
  width: 230px;
}
.statistics-label {
  width: 80px;
}
.terminal-panel {
  background-color:black;
  border: 2px solid #999999;
  border-radius: 10px;
  font: 1rem Inconsolata, monospace;
  color:white;
  overflow: auto;
  padding: 0px;
}
</style>
